import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-login',
  imports: [
    MatButton
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private readonly authService = inject(AuthService);

  login(): void {
    this.authService.login();
  }
}
